import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import ExperienceServices from "./Experience.services";
import GeneralInfoServices from "../GeneralInfo/GeneralInfo.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getExperience = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EXPERIENCE,
      payload: true,
    });
    const resp = await ExperienceServices.getExperience(filters);
    dispatch({
      type: actions.GET_EXPERIENCE,
      payload: {
        experiences: resp.data.data,
        experiencesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.EXPERIENCE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.EXPERIENCE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EXPERIENCE,
      payload: false,
    });
  }
};

export const resetGeneralInfo = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EXPERIENCE,
      payload: true,
    });
    dispatch({
      type: actions.GET_EXPERIENCE,
      payload: {
        experiences: [],
        experiencesLength: 0,
      },
    });
    dispatch({
      type: actions.EXPERIENCE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.EXPERIENCE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EXPERIENCE,
      payload: false,
    });
  }
};

export const getExperienceById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EXPERIENCE_BY_ID,
      payload: true,
    });
    const resp = await ExperienceServices.getExperienceById(id);
    dispatch({
      type: actions.GET_EXPERIENCE_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.EXPERIENCE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.EXPERIENCE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EXPERIENCE_BY_ID,
      payload: false,
    });
  }
};

export const saveExperience = (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_EXPERIENCE,
        payload: true,
      });
      const resp = await ExperienceServices.saveExperience(data);
      const { experiences, experiencesLength } = getState().experience;
      const _experiences = [...experiences, resp.data];
      dispatch({
        type: actions.GET_EXPERIENCE,
        payload: {
          experiences: _experiences,
          experiencesLength: experiencesLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL_EXPERIENCE,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_EXPERIENCE,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_EXPERIENCE,
        payload: false,
      });
    }
  };

export const editExperience = (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_EXPERIENCE,
        payload: true,
      });
      const resp = await ExperienceServices.editExperience(id, data);
      const { experiences, experiencesLength } = getState().experience;
      const dataT = resp.data;
      experiences[index] = dataT;
      dispatch({
        type: actions.GET_EXPERIENCE,
        payload: {
          experiences: experiences,
          experiencesLength: experiencesLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL_EXPERIENCE,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const _data = {
        data:[
          {
            funcion_descriptor:dataT.list_descriptor[0].posicion,
            tipo_mensaje:"Jefe actualiza descriptor"
          }
        ]
      }
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_EXPERIENCE,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_EXPERIENCE,
        payload: false,
      });
    }
  };

  export const editIndispensableExperience = (data, id, index) => async (dispatch, getState) => {
    try {
      // dispatch({
      //   type: actions.LOADING_EXPERIENCE,
      //   payload: true,
      // });
      const resp  =await ExperienceServices.editExperience(id, data);
      const { experiences, experiencesLength } = getState().experience;
      const dataT = resp.data;
      experiences[index] = dataT;
      dispatch({
        type: actions.GET_EXPERIENCE,
        payload: {
          experiences: experiences,
          experiencesLength: experiencesLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL_EXPERIENCE,
        payload: "",
      });
      // setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const _data = {
        data:[
          {
            funcion_descriptor:dataT.list_descriptor[0].posicion,
            tipo_mensaje:"Jefe actualiza descriptor"
          }
        ]
      }
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      // dispatch({
      //   type: actions.FORM_FAIL_EXPERIENCE,
      //   payload: message,
      // });
    } finally {
      // dispatch({
      //   type: actions.LOADING_EXPERIENCE,
      //   payload: false,
      // });
    }
  };

  export const editExperienceById = (data, id, setValidated) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_EXPERIENCE_BY_ID,
        payload: true,
      });
      const resp = await ExperienceServices.editExperience(id, data);
      const dataT = resp.data;
      dispatch({
        type: actions.GET_EXPERIENCE_BY_ID,
        payload: dataT,
      });
      // const { experience, experienceLength } = getState().experience;
      // experience[index] = resp.data;
      // dispatch({
      //   type: actions.GET_EXPERIENCE,
      //   payload: {
      //     experience: experience,
      //     experienceLength: experienceLength,
      //   },
      // });
      setValidated(false)
      dispatch({
        type: actions.FORM_FAIL_EXPERIENCE,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const _data = {
        data:[
          {
            funcion_descriptor:dataT.list_descriptor[0].posicion,
            tipo_mensaje:"Jefe actualiza descriptor"
          }
        ]
      }
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_EXPERIENCE,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_EXPERIENCE_BY_ID,
        payload: false,
      });
    }
  };

export const deleteExperience = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EXPERIENCE,
      payload: true,
    });
    await ExperienceServices.deleteExperience(id);
    const { experiences, experiencesLength } = getState().experience;
    experiences.splice(index, 1);
    dispatch({
      type: actions.GET_EXPERIENCE,
      payload: {
        experiences: experiences,
        experiencesLength: experiencesLength - 1,
      },
    });
    dispatch({
      type: actions.EXPERIENCE_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.EXPERIENCE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EXPERIENCE,
      payload: false,
    });
  }
};
